import type React from "react";

import { Auth0Provider } from "@auth0/auth0-react";
import AuthConfig from "./config/auth"
import { App } from "./App";

const Root: React.FC = () => {
  return (
    <Auth0Provider
      domain={AuthConfig.domain}
      clientId={AuthConfig.clientId}
      cacheLocation="localstorage"
      authorizationParams={{
        redirect_uri: window.location.origin,
        audience: AuthConfig.audience
      }}
    >
        <App />
    </Auth0Provider>
  );
};

export default Root;
